import { render, staticRenderFns } from "./PopularCategories.vue?vue&type=template&id=164ebf98&scoped=true"
import script from "./PopularCategories.vue?vue&type=script&lang=js"
export * from "./PopularCategories.vue?vue&type=script&lang=js"
import style0 from "./PopularCategories.vue?vue&type=style&index=0&id=164ebf98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ebf98",
  null
  
)

export default component.exports